<template>
  <!-- 案件詳細 -->
  <div id="HSTRequestAcceptDetail">
    <div id="container">
      <div class="labelTitle lable">睡眠検査機器配送ｻｰﾋﾞｽ 受付</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td><a @click="showDetail(data.receiptNumber)">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a></td>
            </tr>
            <tr>
              <th>機種</th>
              <td>{{data.instrumentKind}}</td>
            </tr>
            <tr v-if="isWP300(data.instrumentKind)">
              <th>いびきセンサー同梱の有無</th>
              <td>{{setSnoreSensorValue(data.snoreSensor)}}</td>
            <tr>
              <th>依頼元</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.client}}</td>
            </tr>
            <tr>
              <th>医療機関</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospital}}</td>
            </tr>
            <tr>
              <th>患者名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientName}}</td>
            </tr>
            <tr>
              <th>申込日</th>
              <td>{{data.applicationDate}}</td>
            </tr>
            <tr>
              <th>出荷日</th>
              <td>{{data.shippingDate}}</td>
            </tr>
            <tr>
              <th>ePatch同梱の有無</th>
              <td v-if="data.holterRequestId">有</td>
              <td v-else>無</td>
            </tr>
            <tr>
              <th>配達希望時間帯</th>
              <td>{{data.desiredPickupTimeZone | desiredDeliveryTimeZoneFilter(desiredDeliveryTimeZoneList)}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">患者備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">配送備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.DeliveryInformationNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td><textarea v-model="data.receptionNote" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="reception">受付</b-button>
          <b-button class="backButton is-primary" @click="back">戻る</b-button>
        </div>
      </div>
      <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="640" height="480" top="100px" right="100px">
        <hstRequestDetail v-bind:data="data.applicationDetails"/>
      </floatingModal>
    </div>
  </div>
</template>

<script>
import floatingModal from "@/components/mock/common/FloatingModal";
import HSTRequestDetail from "@/components/mock/common/HSTRequestDetail";
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "HSTRequestAcceptDetail", 
  props: ["detailData"],
  methods: {
    back: function () {
      this.$router.push({
        name: "HSTRequestAccept",
        params: { searchConditions: this.searchParams },
      });
    },
    reception: async function() {
      var excuteApi = this.setHstRequestPOST;
      var successCallBack = this.setHstRequestPOSTSuccess;
      var errorCallBack = this.setHstRequestPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHstRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      return client.apis.internalHst.setHstRequestPOST({ 
        body:[obj]
      });
    },
    setHstRequestPOSTSuccess: function(result) {
      this.showSuccess(result,this.back())
    },
    setHstRequestPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    showDetail: function(id) {
      this.$modal.show('detail-modal')
    },
    closeDetail: function(){
      this.$modal.hide('detail-modal')
    },
    doSearch: function() {
      var excuteApi = this.getHstRequestDetailPOST;
      var successCallBack = this.getHstRequestDetailPOSTSuccess;
      var errorCallBack = this.getHstRequestDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHstRequestDetailPOST: function(client) {
      return client.apis.internalHst.getHstRequestDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHstRequestDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getHstRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    isWP300: function(instrumentKind) {
      if(instrumentKind && instrumentKind.match(/ウォッチパット300/)){
        return true
      }
      return false
    },
    setSnoreSensorValue: function(snoreSensor) {
      var setSnoreSensorValue = snoreSensor ? "有" : "無";
      return setSnoreSensorValue;
    }
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    desiredDeliveryTimeZoneList.unshift({})
    return {
      data:[],
      targetNumber,
      searchParams,
      desiredDeliveryTimeZoneList
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  filters: {
    desiredDeliveryTimeZoneFilter: function(val, list){
      if(!val) return val
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: { 
    floatingModal:floatingModal,
    hstRequestDetail:HSTRequestDetail
  }
};
</script>
<style lang="scss" scoped>
.receptionistButton {
    width:100px;
}

table.flowTable,
table.flowTable tr,
table.flowTable td {
    border: 1px solid;
    padding: 0px;
    vertical-align: middle;
}
table.flowTable td {
    width: 40px;
    text-align: center;
}

.delay {
    color: red;
    font-weight: bold; 
}
a {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/hst/HSTRequestAcceptDetail.vue